import type { WorkStatus } from '@kaiizen/kai-scan-template-system';

export const PROGRESS_UPDATE_NOTE_PLACEHOLDER = 'What changed, what to watch for…';

export const canSubmitProgressUpdate = ({
  selectedStatus,
  currentStatus,
  note,
  photoFiles,
}: {
  selectedStatus?: WorkStatus;
  currentStatus?: WorkStatus;
  note: string;
  photoFiles: readonly unknown[];
}): boolean => {
  const statusChanged = !!selectedStatus && selectedStatus !== currentStatus;
  return statusChanged || !!note.trim() || photoFiles.length > 0;
};
